import React, { Fragment } from 'react';
import AliceCarousel from 'react-alice-carousel';
import { v4 as uuidv4 } from 'uuid';

const handleDragStart = (e) => e.preventDefault();

const responsive = {
    0: { items: 1 },
    600: { items: 4 },
    1024: { items: 6 },
};

const LogotypeBlock = (props) => {

    const block = props.result.find(x => x.blockId === props.blockId);
    const getLogotype = (logoType) => {
        const result = [];
        logoType.forEach(x => {
            if (x.imageViewModel) {
                const key = uuidv4();
                if (x.linkUrl) {
                    result.push(
                        <a key={key} href={x.linkUrl} className='logotypeBlock__carousel-item'>
                            <div className='logotypeBlock__carousel-item--image'>
                                <div className='logotypeBlock__carousel-item--image--container'>
                                    <img src={x.imageViewModel.url} alt={x.imageViewModel.alt} onDragStart={handleDragStart} role="presentation" />
                                </div>
                            </div>
                        </a>
                    )
                } else {
                    result.push(
                        <div key={key} className='logotypeBlock__carousel-item'>
                            <div className='logotypeBlock__carousel-item--image'>
                                <div className='logotypeBlock__carousel-item--image--container'>
                                    <img src={x.imageViewModel.url} alt={x.imageViewModel.alt} onDragStart={handleDragStart} role="presentation" />
                                </div>
                            </div>
                        </div>
                    )
                }
            }
        })
        return result;
    }

    return (
        block && block.logotypes?.length > 0 ?
            <div className='grid-system grid-system-within-boundaries'>
                <div className='grid-full-width'>
                    <div className="logotypeBlock">
                        <div className='logotypeBlock__header'>
                            {block.title &&
                                <h3 className='logotypeBlock__header--title'>{block.title}</h3>
                            }
                        </div>
                        {(props.innerWidth > 600 && props.innerWidth <= 1024 && block.logotypes?.length > 3) || (props.innerWidth > 1024 && block.logotypes?.length > 5) ?
                            <div className='logotypeBlock__carousel'>
                                <Fragment>
                                    <div className='logotypeBlock__carousel-rightWhite'></div>
                                    <div className='logotypeBlock__carousel-leftWhite'></div>
                                </Fragment>
                                <AliceCarousel
                                    responsive={responsive}
                                    mouseTracking
                                    items={getLogotype(block.logotypes)}
                                    infinite
                                    renderNextButton={() => {
                                        return (
                                            <div className='logotypeBlock__carousel-next'>
                                                <span></span>
                                            </div>
                                        );
                                    }}
                                    renderPrevButton={() => {
                                        return (
                                            <div className='logotypeBlock__carousel-prev'>
                                                <span></span>
                                            </div>
                                        );
                                    }}

                                />
                            </div>
                            : props.innerWidth <= 600 ?
                                <div className='logotypeBlock__flex'>
                                    {getLogotype(block.logotypes)}
                                </div>
                                :
                                <div className='logotypeBlock__flex-not-mobile'>
                                    {getLogotype(block.logotypes)}
                                </div>
                        }
                        <div className='logotypeBlock__allContainer'>
                            <a className='logotypeBlock__allContainer--seeAll' href={block.link}>{block.linkText}</a>
                        </div>
                    </div>
                </div>
            </div>
            :
            <Fragment></Fragment>
    )
}
export default LogotypeBlock;